import { MODE, WorkCenterWeek } from '../Incrementals.types';
import { UiCommands } from './UiCommands';

// Reset all the user entered data for incrementals
export function cancelEditCommand(
  this: UiCommands,
  workCenterWeek: WorkCenterWeek
) {
  // not best practice to edit the parameter,
  // but it is less expensive than looking it up within uiState by identifiers.
  // workCenterWeek is the in memory reference within uiState,
  // so changing it affects that object within uiState
  const workCenterWeekEdit = workCenterWeek;

  workCenterWeekEdit.days.forEach((day) =>
    day.incrementals.forEach((incrementalCompany) => {
      const incrementalCompanyEdit = incrementalCompany;
      incrementalCompanyEdit.userValue = null;
    })
  );

  workCenterWeekEdit.mode = MODE.NONE;

  workCenterWeekEdit.justificationReason = null;

  this.setUiStateTriggerReRender(this.uiState);
}
